/* tslint:disable */
/* eslint-disable */
/**
 * MachineGo P1 API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import * as runtime from '../runtime';
import {
    BasicModel,
    BasicModelFromJSON,
    BasicModelToJSON,
} from '../models';

export interface AttachmentSubCategoryIdGetRequest {
    subCategoryId: number;
}

/**
 * 
 */
export class AttachmentApi extends runtime.BaseAPI {

    /**
     * Captcha ( Guest = guest )
     */
    async attachmentSubCategoryIdGetRaw(requestParameters: AttachmentSubCategoryIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<runtime.ApiResponse<Array<BasicModel>>> {
        if (requestParameters.subCategoryId === null || requestParameters.subCategoryId === undefined) {
            throw new runtime.RequiredError('subCategoryId','Required parameter requestParameters.subCategoryId was null or undefined when calling attachmentSubCategoryIdGet.');
        }

        const queryParameters: any = {};

        const headerParameters: runtime.HTTPHeaders = {};

        if (this.configuration && this.configuration.accessToken) {
            const token = this.configuration.accessToken;
            const tokenString = await token("Bearer", []);

            if (tokenString) {
                headerParameters["Authorization"] = `Bearer ${tokenString}`;
            }
        }
        const response = await this.request({
            path: `/attachment/{subCategoryId}`.replace(`{${"subCategoryId"}}`, encodeURIComponent(String(requestParameters.subCategoryId))),
            method: 'GET',
            headers: headerParameters,
            query: queryParameters,
        }, initOverrides);

        return new runtime.JSONApiResponse(response, (jsonValue) => jsonValue.map(BasicModelFromJSON));
    }

    /**
     * Captcha ( Guest = guest )
     */
    async attachmentSubCategoryIdGet(requestParameters: AttachmentSubCategoryIdGetRequest, initOverrides?: RequestInit | runtime.InitOverideFunction): Promise<Array<BasicModel>> {
        const response = await this.attachmentSubCategoryIdGetRaw(requestParameters, initOverrides);
        return await response.value();
    }

}
